import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  Title,
  Tooltip,
  Legend,
  BarElement,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import useInvoiceAmount from "./useInvoiceAmount";
import { FormSectionHeader, Loader } from "@/components";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  interaction: {
    mode: "index" as const,
    intersection: false,
  },
  plugins: {
    legend: {
      position: "top" as const,
      labels: {
        usePointStyle: true,
        pointStyle: "circle",
      },
      tooltip: {
        usePointStyle: true,
      },
    },
  },
};

const InvoiceAmount = ({ filterData, selectedYearOption }: any) => {
  const { isReportChartLoading, chartData } = useInvoiceAmount({ filterData, selectedYearOption });

  return isReportChartLoading ? (
    <Loader />
  ) : (
    <>
      <FormSectionHeader className="text-[20px] text-primary">
        Invoice Amount
      </FormSectionHeader>
      <Bar options={options} data={chartData} />
    </>
  );
};

export default InvoiceAmount;
